/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @deprecated use UserServiceAPI instead
 **/

import * as APIs from "./private";

export default function useUsers(events: API.Events = {}, options: API.Options = { initialStart: false }) {
	return {
		//*
		...APIs.withRelatedUsers(events),
		...APIs.withUser(events, options),
		...APIs.withUserOption(events),
		...APIs.withUserStatus(events),
		...APIs.withUserActiveStatus(events),
		...APIs.withSoundNotification(events)
		/*/
		...APIs.withRelatedUsersV2(events),
		...APIs.withUserV2(events),
		...APIs.withUserOptionV2(events),
		...APIs.withUserStatusV2(events),
		...APIs.withUserActiveStatusV2(events)
		//*/
	};
}
